export function formatCounselorLabel(counselor: { userCode: string; firstName: string; lastName: string }): string {
  return `${counselor.userCode} (${counselor.firstName} ${counselor.lastName})`;
}

export default formatCounselorLabel;
